import { render, staticRenderFns } from "./Ultimate.vue?vue&type=template&id=0dca5647&"
import script from "./Ultimate.vue?vue&type=script&lang=js&"
export * from "./Ultimate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports